/**
 * The period the lead's Requests review queue opens on (#1670, #1921).
 *
 * The queue is per period (a request is decided against the period it lands
 * in). The team page's Review tab lists the team's periods newest first and
 * opens on the first; the lead's next-steps panel, on a team page, counts
 * that same period's queue — so the row and the tab it opens agree.
 *
 * `REVIEW_PERIOD_PARAM` (`?review=<cycle id>`) opens the team page's Review
 * tab on a named period (the panel's row on a schedule page passes its own).
 */

export const REVIEW_PERIOD_PARAM = "review";

/** `?leave=YYYY-MM` (the home's Month by month) opens Leave & call-blocks
 *  on its List tab with that month on screen (7 Oct 2026). */
export const LEAVE_MONTH_PARAM = "leave";

/** The `YYYY-MM` a `?leave=` value names, or null. */
export function parseLeaveMonth(raw: string | null): { year: number; monthIndex: number } | null {
  if (!raw || !/^\d{4}-\d{2}$/.test(raw)) return null;
  const year = Number(raw.slice(0, 4));
  const monthIndex = Number(raw.slice(5, 7)) - 1;
  if (monthIndex < 0 || monthIndex > 11) return null;
  return { year, monthIndex };
}

/** The team's periods in the Review tab's order — newest start first. */
export function reviewPeriodsNewestFirst<T extends { horizon_start: string }>(
  cycles: readonly T[],
): T[] {
  return [...cycles].sort((a, b) => b.horizon_start.localeCompare(a.horizon_start));
}

/** The period the Review tab opens on when none is named. */
export function defaultReviewPeriod<T extends { horizon_start: string }>(
  cycles: readonly T[],
): T | null {
  return reviewPeriodsNewestFirst(cycles)[0] ?? null;
}
